import { render, staticRenderFns } from "./MyQrcode.vue?vue&type=template&id=ddcc2d64&scoped=true&"
import script from "./MyQrcode.vue?vue&type=script&lang=js&"
export * from "./MyQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcc2d64",
  null
  
)

export default component.exports